// extracted by mini-css-extract-plugin
module.exports = {"choiceContainer":"Choice_choiceContainer__R1qDT","choice":"Choice_choice__UPJ6A","active":"Choice_active__DybwJ"};